import { render, staticRenderFns } from "./freeGpts.vue?vue&type=template&id=1d2ecc16&scoped=true"
import script from "./freeGpts.vue?vue&type=script&lang=js"
export * from "./freeGpts.vue?vue&type=script&lang=js"
import style0 from "./freeGpts.vue?vue&type=style&index=0&id=1d2ecc16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ecc16",
  null
  
)

export default component.exports